import cx from 'classnames';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React, { useEffect, useRef } from 'react';
import styles from '../layout.module.scss';
export var ContentWidth;
(function (ContentWidth) {
    ContentWidth["FLUID"] = "fluidWidth";
    ContentWidth["FIXED"] = "fixedWidth";
})(ContentWidth || (ContentWidth = {}));
export const Content = ({ children, contentWidth = ContentWidth.FLUID, noPadding = false, disableOverlayScroll = false, shouldScrollOnChildrenChange = false, }) => {
    const contentDivRef = useRef(null);
    useEffect(() => {
        var _a;
        if (shouldScrollOnChildrenChange)
            (_a = contentDivRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
    }, [children, shouldScrollOnChildrenChange]);
    const innerContainerClass = cx(styles.innerContainer, {
        [styles.fixedWidth]: contentWidth === ContentWidth.FIXED,
        [styles.noPadding]: noPadding,
    });
    const pageContent = (React.createElement("main", { className: styles.page },
        React.createElement("div", { className: innerContainerClass }, children)));
    return disableOverlayScroll ? (React.createElement("div", { "data-testid": "content", className: styles.contentNonOverlayScroll, ref: contentDivRef }, pageContent)) : (React.createElement(OverlayScrollbarsComponent, { options: {
            scrollbars: { autoHide: 'move' },
        }, className: cx('os-host-flexbox', styles.contentOverlayScroll) }, pageContent));
};
//# sourceMappingURL=content.js.map